import { AnyQuestionI } from "@seneca/short-answer-service-types";

import { isCalculationQuestion } from "services/shortAnswerService/question-types/typeGuards";

import numHash from "seneca-common/utils/functions/numHash";

export default function enrichEQWithGenerationSeed(stringSeed: string) {
  return <T extends AnyQuestionI>(question: T) => {
    if (isCalculationQuestion(question as AnyQuestionI)) {
      return {
        ...question,
        generationSeed: numHash(stringSeed)
      };
    }
    return question;
  };
}
